import { Hide, Show } from '@styled-icons/boxicons-regular';
import { DreamBlock } from '@typedream/core';
import { setNodes } from '@udecode/plate-core';
import classNames from 'classnames';
import { memo } from 'react';
import { useTPlateEditorRef } from '../../../plate';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { useDreamEditorStore } from '../../../plugins/store';
import toolbarStyles from '../SideToolbar.module.css';

interface VisibilityProps {
  elementKey: 'mobile_hide' | 'desktop_hide'
  label: string
}

function Visibility(props: VisibilityProps) {
  const { elementKey, label } = props;
  const editor = useTPlateEditorRef();

  const currentHide = useDreamEditorStore(() => {
    const element = getSelectedElementEntry<Extract<DreamBlock, { mobile_hide?: any }>>(
      editor,
    )?.[0];

    return !!element?.[elementKey];
  });

  const toggleVisibility = () => {
    const path = getSelectedElementEntry(editor)?.[1];
    setNodes(editor, { [elementKey]: !currentHide }, { at: path });
  };

  return (
    <div className={toolbarStyles.section}>
      <span className={toolbarStyles.label}>{label}</span>
      <button
        type="button"
        className={classNames(toolbarStyles.button)}
        onClick={toggleVisibility}
      >
        {currentHide ? (
          <>
            <span>Hide</span>
            <Hide size={16} className="ml-1" />
          </>
        )
          : (
            <>
              <span>Visible</span>
              <Show size={16} className="ml-1" />
            </>
          )}
      </button>
    </div>
  );
}

export const MobileVisibility = memo(() => (
  <Visibility label="Mobile" elementKey="mobile_hide" />
));

export const DesktopVisibility = memo(() => (
  <Visibility label="Desktop" elementKey="desktop_hide" />
));
